import RoleChip from 'components/Chips/RoleChip';
import { FlexColumn } from 'components/form/generic';
import Textarea from 'components/form/Inputs/Textarea';
import { FC, useMemo } from 'react';
import styled from 'styled-components';
import Interview from 'types/Interview';
import getInterviewNames from 'utils/getInterviewNames';
import InterviewInfo from '../Info';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  & > div {
    width: 100%;
  }
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  row-gap: 1rem;
  margin-bottom: 2rem;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 100%;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

const NameContainer = styled.div`
  font-weight: 500;
  display: flex;
  gap: 1rem;
  font-size: 1.1rem;
`;

const InputContainer = styled.div`
  width: 100%;
`;

type Props = {
  interview: Interview | undefined;
};
const ReviewDisplay: FC<Props> = ({ interview }) => {
  const names: { mentee: string; mentor: string } = useMemo(() => {
    return getInterviewNames(interview);
  }, [interview]);

  return (
    <Container>
      <DescriptionContainer>
        <InputContainer>
          <Textarea
            label="Contenu de l'échange"
            placeholder="Description du contenu de l'échange (renseigné par le mentor)"
            value={interview?.mentorReview?.content}
            rows={5}
            readOnly
          />
        </InputContainer>
        <InterviewInfo interview={interview} />
      </DescriptionContainer>

      <Grid>
        <FlexColumn gap={1.5}>
          <NameContainer>
            {names.mentee} <RoleChip role="MENTEE" />
          </NameContainer>
          <FlexColumn gap={1}>
            <Textarea
              placeholder="Suivi de la progression"
              value={interview?.menteeReview?.progressComment}
              rows={5}
              readOnly
            />
          </FlexColumn>
          <FlexColumn gap={1}>
            <Textarea
              placeholder="Ce que je retiens de nos échanges"
              value={interview?.menteeReview?.qualityComment}
              rows={5}
              readOnly
            />
          </FlexColumn>
          <Textarea
            label="Objectifs et axes de progression pour la prochaine fois"
            placeholder="Besoins exprimés"
            value={interview?.menteeReview?.needs}
            rows={5}
            readOnly
          />
          <Textarea
            label="Prise de notes"
            placeholder="Notes"
            value={interview?.menteeReview?.notes}
            rows={5}
            readOnly
          />
        </FlexColumn>
        <FlexColumn gap={1.5}>
          <NameContainer>
            {names.mentor} <RoleChip role="MENTOR" />
          </NameContainer>
          <FlexColumn gap={1}>
            <Textarea
              placeholder="Suivi de la progression"
              value={interview?.mentorReview?.progressComment}
              rows={5}
              readOnly
            />
          </FlexColumn>
          <FlexColumn gap={1}>
            <Textarea
              placeholder="Ce que je retiens de nos échanges"
              value={interview?.mentorReview?.qualityComment}
              rows={5}
              readOnly
            />
          </FlexColumn>
          <Textarea
            label="Objectifs et axes de progression pour la prochaine fois"
            placeholder="Besoins exprimés"
            value={interview?.mentorReview?.needs}
            rows={5}
            readOnly
          />
          <Textarea
            label="Prise de notes"
            placeholder="Notes"
            value={interview?.mentorReview?.notes}
            rows={5}
            readOnly
          />
        </FlexColumn>
      </Grid>
    </Container>
  );
};

export default ReviewDisplay;
